export { useCurrent } from './useCurrent';
export type { Current } from './useCurrent';
